import type { SvgProps } from 'react-native-svg';
import { SvgXml } from 'react-native-svg';

const xml = `
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
  <path d="M2.11618 11.2472L0.371679 11.9176C0.265952 11.956 0.169836 11.932 0.0833322 11.8455C0.00163397 11.759 -0.019992 11.6605 0.0184542 11.5499L0.724904 9.85591L8.83465 1.75337L10.2187 3.14464L2.11618 11.2472ZM10.9108 2.46703L9.51227 1.07576L10.2908 0.304428C10.483 0.117002 10.6825 0.0160809 10.8891 0.00166354C11.0958 -0.0127538 11.288 0.0665415 11.4658 0.23955L11.747 0.527896C11.9248 0.70571 12.0089 0.895538 11.9993 1.09738C11.9896 1.29922 11.8863 1.49866 11.6893 1.6957L10.9108 2.46703Z" />
</svg>
`;

export const Pencil = (props: SvgProps) => (
  <SvgXml xml={xml} width="100%" height="100%" {...props} />
);
